import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Skeleton from "@mui/material/Skeleton";

// Mirrors FixWasteTable's layout: index + name + 13 equal-width columns (no note
// column). Rendered while the reconcile waste details are loading so the page
// never shows an empty/broken table.
const COLUMN_COUNT = 15;

export default function FixWasteSkeleton() {
  const rows = Array.from({ length: 10 });
  const cols = Array.from({ length: COLUMN_COUNT });

  return (
    <TableContainer sx={{ overflowX: "auto" }}>
      <Table>
        <TableHead>
          <TableRow>
            {cols.map((_, i) => (
              <TableCell key={i}>
                <Skeleton height={24} />
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((_, rowIndex) => (
            <TableRow
              key={rowIndex}
              sx={{ bgcolor: rowIndex % 2 ? "#f6f6f9" : "#fff" }}
            >
              {cols.map((_, colIndex) => (
                <TableCell key={colIndex} sx={{ padding: "4px" }}>
                  <Skeleton height={32} />
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
